import { css } from '@/styled-system/css';

export const bannerBodyStyles = css.raw({
  display: 'flex',
  justifyContent: 'center',
  flex: '0 1 auto',
  gap: 'Banner.gap.leading',
  color: 'inherit',
  textStyle: 'body',
});
